import * as yup from 'yup';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { hasNoHsnTsn } from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';
import { testSpecialChars } from '@/utils/strings/strings';

export const herstellerValidator = (value: string | undefined): boolean => {
  if (value === undefined) return false;

  return !getSimpleChoiceMeta(
    SIMPLE_CHOICE.HERSTELLERLISTE,
    SIMPLE_CHOICE_META.KFZ_EMPTY_HERSTELLER,
  ).includes(value);
};

export const fahrzeugContractSchema = yup.object({
  kennzeichen: yup.string().default('').required(),
  fahrzeugIDNummer: yup
    .string()
    .length(
      17,
      'Die Fahrzeug-Identifikationsnummer muss genau 17 Stellen haben.',
    )
    .matches(
      /^(\d|\w)+$/,
      'Die Fahrzeug-Identifikationsnummer darf nur Buchstaben und Zahlen enthalten',
    )
    .default('')
    .required(),
  hersteller: yup
    .string()
    .default('')
    .when({
      is: () => hasNoHsnTsn.value,
      // is: true,
      then: yup
        .string()
        .required()
        .test(
          'isValidHersteller',
          'Bitte wählen Sie einen Hersteller aus.',
          herstellerValidator,
        ),
    })
    .test(testSpecialChars),
});

export type FahrzeugContractObject = yup.Asserts<typeof fahrzeugContractSchema>;
